// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2879":"0da326dbd0e6cde9","2888":"f57995c56fcf9b69"}[chunkId] + ".css";
};